import React, {FC, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import axios from "axios";
import {Helmet} from "react-helmet";
import BgGlassmorphism from "../../components/BgGlassmorphism/BgGlassmorphism";
import SectionCoin from "./SectionCoin";
import SectionCoin2 from "./SectionCoin2";
import SectionCarousel from "containers/PageMarkets/SectionCarousel";
import {DEMO_CATEGORIES} from "../../data/Markets";
import {setInterval} from "timers";
import {PageMarketsProps} from "../PageMarkets/PageMarkets";

export interface PageCoinProps {
  className?: string;
}

const PageCoin = () => {
  let {coin} = useParams<{ coin: string }>();
  const [data, setData] = useState<any>();

  useEffect(() => {
    const coinDataURL = `https://api.coingecko.com/api/v3/coins/${coin}`;
    axios.get(coinDataURL).then((response) => {
      setData(response.data);
    })
  }, [])

  return (
    <div
      className={`PageCoin overflow-hidden relative $`}
      data-id="PageCoin"
    >
      <Helmet>
        <title>{coin}/GBP | CryptoVerse</title>
      </Helmet>
      <BgGlassmorphism />
      <SectionCarousel />
      {data ?
        <div>
          <div className="relative overflow-hidden"></div>
          <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
              <SectionCoin data={data}/>
              <SectionCoin2 coinName={data?.name}/>
          </div>
        </div>
        :
        <>Fetching {coin} data ...</>
      }
    </div>
  );
};


export default PageCoin;
